import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const DeliveryHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="delivery" t={t}>
      <Box mb={3}>
        <H3>Zustellungsdatum</H3>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Das korrekte Zustellungsdatum ist Voraussetzung für die Gültigkeit einer Nachzahlungsforderung. Hier gilt das
          Datum, an welchem der Mieter die Abrechnung
          <b>wirklich erhalten</b>
          hat. Absendedatum und Poststempel sind unerheblich.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Ab ordnungsgemäßer Zustellung der Abrechnung haben Sie ein Jahr Zeit, um
          <b>Widerspruch</b>
          gegen die Abrechnung einzureichen. Eine nicht fristgerechte Zustellung der Nebenkostenabrechnung seitens Ihres
          Vermieters kann für Sie die positive Folge haben, dass Sie seinen
          <b>Forderungen nicht nachkommen</b>
          müssen. Auf eventuelles Guthaben können Sie dennoch weiterhin bestehen.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Bei Zusendungen per Post muss der Vermieter eine ordentliche Zustellung der Abrechnung
          <b>beweisen</b>
          können. Hier verbirgt sich Streitpotential, wenn der Mieter den Erhalt bestreitet und der Vermieter die
          Zustellung nicht beweisen kann. Alternative Zustellungsmöglichkeiten sind die
          <b>persönliche Zustellung</b>
          und eine Zustellung per
          <b>Einschreiben mit Rückschein.</b>
          Hier wird die Abrechnung nur gegen eine Empfangsbestätigung des Mieters zugestellt.
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default DeliveryHelp;
